<!-- TODO: REFACTORIZAR A UN SOLO COMPONENTE -->
<div class="reset-container">
    <div>
        <div class="d-flex py-3">
            <span class="material-symbols-rounded square-icon">lock</span>
            <p class="app-module-title my-auto ms-3">Ingresa una nueva contraseña</p>
        </div>
        <form [formGroup]="passwordForm">
            <mat-form-field floatLabel="never" class="w-100 mb-3">
                <span matPrefix
                    class="login-input-icon material-symbols-rounded ms-2">
                    lock
                </span>
                <input matInput
                    autofocus
                    type="password"
                    id="input-password"
                    autocomplete="suggest-password"
                    placeholder="Contraseña"
                    required
                    formControlName="password"/>
            </mat-form-field>
            <div class="d-flex flex-row align-items-center gap-3" *ngIf="
                passwordForm.get('password').hasError('minlength')
                && passwordForm.get('password').touched">
                <img src="../../../assets/img/error-circle-100.svg"
                     width="32"
                     height="32"
                     alt="Account Error">
                <p class="text-danger">Comprueba que la contraseña tenga al menos 8 caracteres.</p>
            </div>
            <div class="d-flex flex-row align-items-center gap-3" *ngIf="
                passwordForm.get('password').hasError('required')
                && passwordForm.get('password').touched">
                    <img src="../../../assets/img/error-circle-100.svg"
                         width="32"
                         height="32"
                         alt="Account Error">
                    <p class="text-danger m-0 py-2">Ingresa una contraseña segura.</p>
            </div>
            <mat-form-field floatLabel="never" class="w-100 mb-3">
                <span matPrefix
                    class="login-input-icon material-symbols-rounded ms-2">
                    lock
                </span>
                <input matInput
                    type="password"
                    id="input-password-two"
                    autocomplete="suggest-password"
                    placeholder="Confirmación de Contraseña"
                    required
                    formControlName="passConfirmation"
                    (keyup.enter)="requestPasswordReset()"
                />
            </mat-form-field>
            <div class="d-flex flex-row align-items-center gap-3" *ngIf="passwordForm.get('passConfirmation').hasError('minlength')">
                <img src="../../../assets/img/error-circle-100.svg"
                     width="32"
                     height="32"
                     alt="Account Error">
                <p class="text-danger">Comprueba que la contraseña tenga al menos 8 caracteres.</p>
            </div>
            <div class="d-flex flex-row align-items-center gap-3" *ngIf="passwordForm.get('passConfirmation').hasError('required')">
                <img src="../../../assets/img/error-circle-100.svg"
                     width="32"
                     height="32"
                     alt="Account Error">
                <p class="text-danger">Confirma tu contraseña.</p>
            </div>
            <div class="d-flex flex-row align-items-center gap-3" *ngIf="passwordForm.hasError('passwordDoCheck')">
                <img src="../../../assets/img/error-circle-100.svg"
                     width="32"
                     height="32"
                     alt="Account Error">
                <p class="text-danger">Las contraseñas no coinciden.</p>
            </div>
        </form>
        <button mat-flat-button
                class="w-100 role-action-btn"
                type="button"
                (click)="requestPasswordReset()">
            Confirmar
        </button>
    </div>
</div>
